import classNames from 'classnames'
import React from 'react'
import SimpleTimeField from 'react-simple-timefield'
import css from './timeField.css'
type Props = {
  label?: string
  name?: string
  value?: string
  placeholder?: string
  className?: string
  onChange?: (...args: Array<any>) => any
}

const TimeField = ({ label, className, ...inputProps }: Props) => (
  <div className={classNames(css.component, className)}>
    <label>
      {label && <p className={css.label}>{label}</p>}
      <div className={css.input}>
        <SimpleTimeField {...inputProps} />
      </div>
    </label>
  </div>
)

export default TimeField
